import { render } from "./editPrescription.vue?vue&type=template&id=5b71abf4&scoped=true"
import script from "./editPrescription.vue?vue&type=script&lang=js"
export * from "./editPrescription.vue?vue&type=script&lang=js"

import "./editPrescription.vue?vue&type=style&index=0&id=5b71abf4&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b71abf4"]])

export default __exports__